export const Styles = {
  notificationContainer: {
    position: "fixed" as const,
    // Offset below the app-top banner stack so toasts never cover it.
    top: "calc(var(--app-banner-h, 0px) + 70px)",
    right: "16px",
    zIndex: 999999,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-end",
    gap: "8px",
    maxWidth: "420px",
  },
};
